/*
 * @Author       : zhaobo
 * @Date         : 2020-10-24 19:57:54
 * @LastEditors  : zhaobo
 * @LastEditTime : 2021-04-09 18:13:29
 * @Description  :
 */
export default () => {
  return {
    pageSize: 10,
    category: [
      {
        label: '全部',
        value: '',
        type: 0,
      },
      {
        label: '政策文件',
        value: 'policy',
        type: 1,
      },
      {
        label: '政策解读',
        value: 'interpret',
        type: 2,
      },
      {
        label: '领导讲话',
        value: 'speech',
        type: 3,
      },
      {
        label: '红头文件',
        value: 'official',
        type: 4,
      },
      {
        label: '参考案例',
        value: 'reference',
        type: 5,
      },
    ],
  };
};
